/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;



//////////////////
// WEBPACK FOOTER
// ../node_modules/lodash/_freeGlobal.js
// module id = 223
// module chunks = 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35